import "@/App.css";
import { LangProvider } from "@/lib/lang";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Leaks } from "@/components/site/Leaks";
import { Process } from "@/components/site/Process";
import { Categories } from "@/components/site/Categories";
import { Model } from "@/components/site/Model";
import { Calculator } from "@/components/site/Calculator";
import { Founder } from "@/components/site/Founder";
import { Audience } from "@/components/site/Audience";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { ChatWidget } from "@/components/site/ChatWidget";

function App() {
  return (
    <LangProvider>
      <SmoothScroll />
      <div className="grain" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Leaks />
        <Process />
        <Categories />
        <Model />
        <Calculator />
        <Founder />
        <Audience />
        <Contact />
      </main>
      <Footer />
      <ChatWidget />
    </LangProvider>
  );
}

export default App;
